import { Component, inject} from '@angular/core';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';
import { Router } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { Notification } from '../../../../models/notification.model';
import { AppService } from '../../../../services/app.service';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  imports: [
    CommonModule,
    MatCardModule,
    MatIconModule,
    MatButtonModule,
  ],
  providers: []
})
export default class NotificationComponent {
  public notifications$!: Observable<Notification[]>;

  private readonly appService = inject(AppService);
  private readonly router = inject(Router);


  constructor() {
    this.notifications$ = this.appService.getAll();
  }


  onClose(notificationId: number): void {
    this.appService.close(notificationId).pipe(
      first()
    ).subscribe(
      () => this.notifications$ = this.appService.getAll()
    );
  }

  
  openLink(actionLink: string): void {
    this.router.navigate([`${actionLink}`]);
  }

}
